import { ListGroup, ListGroupItem } from "react-bootstrap";
import React from "react";
import { useSelector } from "react-redux";
import { getSafe } from "../../util/storeHelper";
import EnvButton from "./EnvButton";
export default function Environment(props) {
    const { t, onEditEnv, environment, addEnv, removeEnv } = props;
    const { displayGroups } = useSelector(mapStateToProps);
    const envList = Object.keys(environment).map((key) => ({
        key,
        value: environment[key],
    }));
    const group = getSafe(displayGroups, ["envEdit"], undefined);
    const editEnv = (itemId) => onEditEnv(itemId);
    return (React.createElement(ListGroup, null,
        envList.map((env) => (React.createElement(ListGroupItem, { key: env.key },
            React.createElement(EnvButton, { t: t, variable: env, open: group === env.key, onAdd: addEnv, onRemove: removeEnv, onOpen: editEnv })))),
        React.createElement(ListGroupItem, { key: "__add" },
            React.createElement(EnvButton, { t: t, open: group === "__add", onAdd: addEnv, onRemove: removeEnv, onOpen: editEnv }))));
}
function mapStateToProps(state) {
    return {
        displayGroups: state.session.base.displayGroups,
    };
}
